import { useTranslation } from 'react-i18next';
import { SEO } from '../../components-new/SEO/SEO';
import { AnimatedSection } from '../../components-new/AnimatedSection/AnimatedSection';
import { ContactForm } from '../../components-new/ContactForm/ContactForm';
import './style.less';

export const Contact = () => {
  const { t } = useTranslation();

  return (
    <div className="contact-page">
      <SEO
        title={t('contact.seo.title')}
        description={t('contact.seo.description')}
        keywords={t('contact.seo.keywords')}
      />
      <section className="section page-hero">
        <div className="container">
          <AnimatedSection>
            <h1>{t('contact.title')}</h1>
            <p>{t('contact.subtitle')}</p>
          </AnimatedSection>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-content">
            <AnimatedSection className="contact-form-wrapper">
              <ContactForm />
            </AnimatedSection>

            <AnimatedSection className="contact-info" delay={0.2}>
              <h3>{t('contact.info.title')}</h3>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div>
                  <p className="info-label">{t('contact.info.email')}</p>
                  <a href="mailto:contact@sginterior.bg">stefani.georgieva@interior-sg.com</a>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div>
                  <p className="info-label">{t('contact.info.phone')}</p>
                  <a href="tel:+359888123456">+359 88 627 5939</a>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div>
                  <p className="info-label">{t('contact.info.address')}</p>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=%D1%83%D0%BB.+%D0%A1%D1%82%D0%B0%D1%80%D0%B0+%D0%9F%D0%BB%D0%B0%D0%BD%D0%B8%D0%BD%D0%B0+34+%D0%A1%D0%B5%D0%B2%D0%BB%D0%B8%D0%B5%D0%B2%D0%BE+%D0%91%D1%8A%D0%BB%D0%B3%D0%B0%D1%80%D0%B8%D1%8F"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('contact.info.addressValue')}
                  </a>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fas fa-clock"></i>
                </div>
                <div>
                  <p className="info-label">{t('contact.info.workingHours')}</p>
                  <p>{t('contact.info.workingHoursValue')}</p>
                </div>
              </div>

              {/* <div className="info-item holiday-hours">
                <div className="info-icon">
                  <i className="fas fa-tree"></i>
                </div>
                <div>
                  <p className="info-label">{t('contact.info.holidayHours')}</p>
                  <p>{t('contact.info.holidayHoursValue')}</p>
                </div>
              </div> */}
            </AnimatedSection>
          </div>
        </div>
      </section>
    </div>
  );
};
